import React from 'react';

function FilledInfo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.8 4.80098C8.8 5.2428 8.44183 5.60098 8 5.60098C7.55817 5.60098 7.2 5.2428 7.2 4.80098C7.2 4.35915 7.55817 4.00098 8 4.00098C8.44183 4.00098 8.8 4.35915 8.8 4.80098ZM7.20005 7.06706C7.20005 6.69887 7.49853 6.40039 7.86672 6.40039H8.13338C8.50157 6.40039 8.80005 6.69887 8.80005 7.06706V11.3337C8.80005 11.7019 8.50157 12.0004 8.13338 12.0004H7.86672C7.49853 12.0004 7.20005 11.7019 7.20005 11.3337V7.06706Z"
        fill="#998FD7"
      />
    </svg>
  );
}

export default FilledInfo;
